import { Box, Text } from '@factorialco/deprecated-design-system'

import FileCard from 'modules/bookkeepers/components/IncidenceInformation/FileCard'
import type File from 'modules/bookkeepers/store/models/File'

interface Props {
  label?: string
  files: File[]
}

const Attachments = ({ files, label }: Props) => {
  return (
    <Box gap="s8">
      {label && (
        <Text.Normal size="200" color="grey800">
          {label}
        </Text.Normal>
      )}
      {files.map((file) => (
        <FileCard file={file} key={file.id} />
      ))}
    </Box>
  )
}

export default Attachments
